<script setup>
import { addressListAPI} from '@/apis/user'
import { setChangeAddressAPI} from '@/apis/order'
import addressView from '@/components/addressView/index.vue'

import topUpView from '@/components/topUpView/index.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const emits=defineEmits(['getAddress'])
const props=defineProps(['id','expired_at','orderNo'])
const curAddress = ref({}) // 默认地址
// 切换地址
const activeAddress = ref({})
const switchAddress = (item) => {
    activeAddress.value = item
}

// 控制弹框打开
const showDialog = ref(false)
const openSwitchAddressModel=()=>{
    showDialog.value = true
    activeAddress.value=curAddress.value
}
//切换地址确认
const confirm = async () => {
    // console.log(activeAddress.value)
    if(props.id &&props.orderNo){//地址id和订单id存在切换地址调用接口
        curAddress.value = activeAddress.value
        //调用切换地址接口
        
        console.log(curAddress.value)
        let data={
            order_no:props.orderNo,
            address_id:curAddress.value.id,
            shipping_phone:`${curAddress.value.area_code}${curAddress.value.mobile}`,
            shipping_name:`${curAddress.value.surname}${curAddress.value.name}`,
        }
        const res = await setChangeAddressAPI(data);
        if(res.code==0){
            ElMessage({ type: 'success', message: t('cart48') })
        }
        showDialog.value = false
        activeAddress.value = {}
    }else{
        curAddress.value = activeAddress.value
        emits('getAddress',curAddress.value)
        showDialog.value = false
        activeAddress.value = {}
    }
    
}
const addressAll=ref([])
const getAddressInfo=async ()=>{
    const res = await addressListAPI();
    addressAll.value = res.data.list
    let item={}
    console.log('获取地址',props.id)
    if(props?.id){
        console.log('地址',props.id)
    //存在地址id的
     item = addressAll.value.find(item => item.id === props.id)
     console.log(item)
     if(item==undefined&&addressAll.value.length>0){
        item=addressAll.value[0]
        activeAddress.value=item
        confirm()
     }
    }else{
        // 适配默认地址
        if(addressAll.value.length>0){
            item = addressAll.value.find(item => item.default === 1)
            console.log('item',item)
            if(!item){//没有默认拿第一个
                item=addressAll.value[0]
            }
        }
        
    }
   

    curAddress.value = item
    activeAddress.value=curAddress.value
    emits('getAddress',curAddress.value)
}

const dialogAddress = ref(false)
const handleClose = () => {
    dialogAddress.value = false
    getAddressInfo()
}
const infoId=ref()//地址id
//新增地址
const showAddress = () => {
    infoId.value=null
    dialogAddress.value = true
}
//编辑地址
const edit=(id)=>{
    infoId.value=id;
    dialogAddress.value = true
}

const handleAddress=()=>{
    
    if(Object.keys(curAddress.value).length!==0){
    }else{
        openSwitchAddressModel()
    }
}

const isMobile=ref(false)
onMounted(() => {
    
    getAddressInfo()
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
   
}
)
</script>
<template>
    <div style="width: 100%;display: flex;justify-content: center;">
        <!-- 收货地址 -->
        <div class="wrapper-address" v-if="isMobile==false">
            <div class="addressTop">
               
                <div class="address-title">{{ $t('cart20') }}</div>
            </div>
            <div class="alignflex" v-if="props.expired_at" style="padding-bottom: 20px;">
                {{ $t('setup483') }}<span> <el-countdown  :value="props.expired_at" /></span>{{ $t('setup484') }}
            </div>
            <div class="addressContent">
                <div style="display: flex;">
                    <div class="address-content-img"><img src="../../assets/images/address.png" alt=""></div>
                    <div class="address-content-ul">
                    <div v-if="!curAddress?.surname">
                        <div>{{ $t('cart18') }}</div>
                    </div>
                    <div v-else>
                        <div class="none" v-if="!curAddress" @click="showAddress">{{ $t('setup55') }} <svg-icon icon-class="add" style="width: 40px;height: 27px;" class="phone"/></div>
                            <ul v-else >
                                <li style="display: flex;align-items: center;"><div class="Default" v-if="curAddress.default==1">{{ $t('number30') }}</div><div style="color: #888888;">{{ curAddress.country }}, {{ curAddress.province }}, {{
                                    curAddress.city }}</div></li>
                                <li style="font-size: 16px;color:#11192D;"><span>{{ curAddress.area }}</span></li>
                                <li style="color: #333333;"><span>{{curAddress.area_code}}{{ curAddress.mobile }}&nbsp;&nbsp;{{ curAddress.surname }}{{ curAddress.name }}</span></li>
                            </ul>
                        </div>
                    </div>
                   
                </div>
                <div style="display: flex;">
                    <div class="addressBUT" @click="openSwitchAddressModel()" style="margin-right: 15px;">{{ $t('cart25') }}</div>
                    <div class="addressBUT" @click="showAddress">{{ $t('cart26') }}</div>
                </div>
            </div>
        </div>
        <div v-else class="phoneAddress">
            <div class="alignflex" v-if="props.expired_at" style="padding-bottom: 20px;">
                {{ $t('setup483') }}<span> <el-countdown  :value="props.expired_at" /></span>{{ $t('setup484') }}
                </div>
            <div class="content" @click="handleAddress">
                
                    <div class="left-img"><img src="../../assets/images/address3.png" alt="" srcset=""></div>
                    <div v-if="Object.keys(curAddress).length===0" >
                        <div>{{ $t('cart18') }}</div>
                    </div>
                    <div v-else>
                        <div class="add-content">
                            <div class="name"><div class="Default">{{ $t('number30') }}</div><span>{{ curAddress.surname }}{{ curAddress.name }}&nbsp;&nbsp;{{curAddress.area_code}}{{ curAddress.mobile }}</span></div>
                            <div class="ellipsis-2">{{ curAddress.country }}, {{ curAddress.province }},{{ curAddress.city }}, {{ curAddress.area }}</div>
                        </div>
                    </div>
                    <div class="end-img" @click="openSwitchAddressModel()"><img src="../../assets/images/you.png" alt="" srcset=""></div>
            
            </div>
            <div class="content-Bottom"><img src="../../assets/images/addressBottom.png" style="height: 3px;" alt="" srcset=""></div>
        </div>
        <div v-if="isMobile == false">
                <!-- 切换地址 -->
                <el-dialog v-model="showDialog" :show-close="false" width="524px" class="model">
                    <template #header="{ close, titleId, titleClass }">
                    <div class="my-header">
                    
                        <div class="close" ><img src="../../assets/images/closure.png" alt="" srcset="" @click="close()" style="width: 18px; height: 18px;"></div>
                        <div class="model-title" :id="titleId" :class="titleClass">{{$t('cart35')}}</div>
                    </div>
                    </template>
                <!-- <el-dialog class="pc" v-model="showDialog" :title="$t('cart35')" width="524px" center> -->
                    <div class="addressWrapper">
                        <div class="text item" :class="{ active: activeAddress.id === item.id }"
                            @click="switchAddress(item)" v-for="item in addressAll" :key="item.id">
                            <div class="img"><img src="../../assets/images/addresss.png" alt=""></div>
                            <ul>
                                <li style="display: flex;align-items: center;"><div class="Default" style="width: 50px;"  v-if="item.default==1">{{ $t('number30') }}</div><div style="color: #888888;">{{ item.country }}, {{ item.province }}, {{
                                    item.city }}</div></li>
                                <li style="font-size: 16px;color:#11192D;"><div>{{ item.area }}</div></li>
                                <li style="color: #333333;"><div>{{item.area_code}}{{ item.mobile }}&nbsp;&nbsp;{{ item.surname }}{{ item.name }}</div></li>
                            </ul>
                        </div>
                    </div>
                    <template #footer >
                            <div style="display: flex;justify-content: center;">
                        
                            <div class="Cancel" @click="showDialog = false" >{{ $t('cart36') }}</div>
                            <div class="define" @click="confirm">{{ $t('cart37') }}</div>
                        </div>
                    </template>
                </el-dialog>
                <!-- 添加地址 -->
                <!-- <el-dialog class="pc" v-model="dialogAddress" :title="t('cart15')" width="500" :before-close="handleClose"> -->
                <el-dialog v-model="dialogAddress" :show-close="false" width="524px" class="model">
                    <template #header="{ titleId, titleClass }">
                    <div class="my-header">
                    
                        <div class="close" ><img src="../../assets/images/closure.png" alt="" srcset="" @click="handleClose()" style="width: 18px; height: 18px;"></div>
                        <div class="model-title" :id="titleId" :class="titleClass">{{$t('cart15')}}</div>
                    </div>
                    </template>
                    <div>
                        <addressView :id="infoId" @handleClose="handleClose"></addressView>
                    </div>
                </el-dialog>
                <topUpView class="pc" v-if="topUpVisible" @handleClose="topUpClose" :model="topUpVisible"></topUpView>
        </div>
        <div v-else>
            <!-- 切换地址 -->
            <el-drawer  :show-close="false" v-model="showDialog"  direction="btt"  size="88%">
                <template #header="{ titleId, titleClass }">
                    <div class="showDialogtitle" :id="titleId" :class="titleClass">{{ $t('cart35') }}</div>
                    <div style="width: 16px;height: 16px;" @click="showDialog = false">
                        <img src="../../assets/images/closure.png" alt="" srcset="">
                    </div>
                    </template>
                    <div style="width: 100%;">
                        
                        <div  :class="{ actives: activeAddress.id === item.id }"
                            @click="switchAddress(item)" v-for="item in addressAll" :key="item.id">
                                <div class="item">
                                <div class="checkimg">
                                    <img src="../../assets/images/check.png" alt="" srcset="" v-if="activeAddress.id === item.id">
                                    <img src="../../assets/images/nocheck.png" alt="" srcset="" v-else>
                                </div>
                                <div class="content-model">
                                    <div>{{ item.surname }}{{ item.name }}&nbsp;&nbsp;{{item.area_code}}{{ item.mobile }}</div>
                                    <div class="ellipsis-2 ">{{ item.country }} {{ item.province }}{{
                                            item.city }} {{ item.area }}</div>
                                </div>
                                <div style="width: 18px; height: 18px;margin-left: 27px;" @click="edit(item.id)">
                                    <img src="../../assets/images/edit.png" alt="" srcset="">
                                </div>
                            </div>
                            <div class="hrdiv"></div>
                                
                        </div>
                    </div>
                <template #footer>
                    <div class="dialog-footer">
                        <div class="addbut HorizontalCenter" @click="showAddress">
                            {{ $t('setup55') }}
                        </div>
                        <div class="confirm HorizontalCenter" @click="confirm">
                            {{ $t('cart37') }}
                        </div>
                        <!-- <el-button @click="showDialog = false">{{ $t('cart36') }}</el-button>
                        <el-button type="primary" @click="confirm">{{ $t('cart37') }}</el-button> -->
                    </div>
                </template>
            </el-drawer>
            <!-- 添加地址 -->
            <!-- <el-drawer class="phone" v-model="dialogAddress" :title="t('cart15')"   direction="btt"  size="88%"
                :before-close="handleClose"> -->
                <el-drawer  :show-close="false" v-model="dialogAddress"  direction="btt"  size="88%">
                <template #header="{ titleId, titleClass }">
                    <div class="showDialogtitle" :id="titleId" :class="titleClass">{{ $t('cart15') }}</div>
                    <div style="width: 16px;height: 16px;" @click="handleClose">
                        <img src="../../assets/images/closure.png" alt="" srcset="">
                    </div>
                    </template>
                <div>
                    <addressView :id="infoId" @handleClose="handleClose"></addressView>
                </div>
            </el-drawer>
            <topUpView class="phone" v-if="topUpVisible" @handleClose="topUpClose" :model="topUpVisible"></topUpView>
        </div>
    </div>
</template>
<style scoped lang="scss">
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 0.01rem;
    opacity: 0;
    display: none;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    background-color: #fff;
    opacity: 0;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    width: 0.01rem;
    border-radius: 0.01rem;
    opacity: 0;
}
 .Default{
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #FC3938;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    width: 50px;
    height: 16px;
    background: #FEF1EA;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
}
 .wrapper-address{
            width: 1200px;
            height: auto;
         background: #FFFFFF;
         border-radius: 8px;
         padding: 20px 20px;
         .addressTop{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 17px;
            .address-title{
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #11192D;
            line-height: 24px;
            text-align: left;
            font-style: normal;
         }
        
         }
         .addressContent{
            padding: 22px 15px 16px 15px;
            border-radius: 8px;
            border: 1px solid #E5E8EC;
            display: flex;
    width: 100%;
    justify-content: space-between;
            .address-content-img{
                width: 22px;
                height: 25px;
                margin-right: 10px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .addressBUT{
                height: 40px;
                background: #FFFFFF;
                border-radius: 20px;
                border: 1px solid #E5E8EC;
                padding: 0 26px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .address-content-ul{
            //    flex: 1;
               width: 662px;
                .none {
                    line-height: 90px;
                    color: #999;
                    text-align: center;
                    width: 100%;
                }
                >ul {
            flex: 1;
            // padding: 20px;

            li {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                line-height: 19px;
                text-align: left;
                font-style: normal;
                padding-bottom: 5px;
            }
        }

        >a {
            color: $xtxColor;
            width: 160px;
            text-align: center;
            height: 90px;
            line-height: 90px;
            border-right: 1px solid #f5f5f5;
        }
    }
            }
        
        
        }
.addressWrapper {
    max-height: 326px;
    overflow-y: auto;
}
.model{
    .close{
        display: flex;
        justify-content: flex-end;
    }
    .model-title{
        text-align: center;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #11192D;
        line-height: 24px;
        font-style: normal;
    }
}
.text {
    // flex: 1;
    min-height: 90px;
    display: flex;
    // align-items: center;
    // display: flex
;
    align-items: flex-start;
    &.item {
        border: 1px solid #f5f5f5;
        margin-bottom: 10px;
        cursor: pointer;
        padding: 18px 15px;
        width: 464px;
        &.active,
        &:hover {
            border-radius: 8px;
            border: 1px solid #FC3938;
        }

        >ul {
            div{
                width: 340px;
           white-space: nowrap; /* 强制文本在一行显示 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 超出部分显示为省略号 */
  display: block; /* 确保 li 是块级元素 */
            }
          
            // line-height: 30px;
        }
       
    }
    .img{
            margin-right: 10px;
            width: 22px;
            height: 25px;
        }
}
.define{
    background: #FB7700;
border-radius: 23px;
font-family: MicrosoftYaHei;
font-size: 14px;
color: #FFFFFF;
line-height: 19px;
text-align: left;
font-style: normal;
padding: 10px 53px;
}
.Cancel{
    font-family: MicrosoftYaHei;
font-size: 14px;
color: #333333;
line-height: 19px;
text-align: left;
font-style: normal;
border-radius: 23px;
border: 1px solid #E1E1E1;
padding: 10px 53px;
margin-right: 15px;

}
@media (max-width: 768px) {
    .phoneAddress{
        background: #FFFFFF;
        box-shadow: 0px 4px 20px 6px rgba(237,237,237,0.75);
        border-radius: 8px;
        width: 100%;
        padding: 23px 13px 10px 13px;

        .content{
           
                display: flex;
            align-items: center;
            justify-content: space-between;
            .left-img{
                width: 16px;
                height: 20px;
                margin-right: 0px;
            }
            .add-content{
                .name{
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #222222;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    display: flex;
                    align-items: center;
                    margin-bottom: 9px;
                    .Default{
                        font-family: MicrosoftYaHei;
                        font-size: 10px;
                        color: #FC3938;
                        line-height: 14px;
                        text-align: left;
                        font-style: normal;
                        padding: 1px 4px;
                    }
                }
                .ellipsis-2{
                    width: 270px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                }
                
            }
            .end-img{
                width: 5px;
                height: 10px;
                margin-left: 21px;
            }
            }
            
           
        
        .content-Bottom{
            margin-top: 11px;
                height: 3px;
            }
    }
    .showDialogtitle{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #222222;
        line-height: 20px;
        text-align: left;
        font-style: normal;
    }
    .checkimg{
        width: 16px;
        height: 16px;
        margin-right: 10px;
    }
    .item{
        display: flex;
        align-items: center;
        padding: 15px 0;
        width: 100%;
        justify-content: space-between;
    }
    .content-model{
        flex: 1;
        width: 253px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        text-align: left;
        font-style: normal;
    }
    .dialog-footer{

        display: flex;
        justify-content: space-between;
        .addbut{
        width: 160px;
        height: 40px;
        border-radius: 20px;
        border: 1px solid #FC3938;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FC3938;
        line-height: 22px;
        text-align: left;
        font-style: normal;
    }
    .confirm{
        width: 160px;
        height: 40px;
        background: #FC3938;
        border-radius: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: left;
        font-style: normal;
    }
    }
  
}
</style>